/** How long purchased credits last, shown wherever a top-up is bought; nothing when they never expire. */
export function TopupLifetimeNote({ months, className }: { months: number | null; className?: string }) {
  if (months === null) return null
  return <p className={className}>{`Top-up credits are valid for ${months} ${months === 1 ? 'month' : 'months'}.`}</p>
}
